<template>
  <form ref="formRollQuantity">
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <h2 class="emd-text _color_default _type_caption">
              {{ $t('title') }}
            </h2>
            <p class="emd-text _size_small _color_nonessential eu-mt_1">
              {{ $t('description') }}
            </p>
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <div class="emd-form-group">
              <label
                class="emd-label _required"
                for="kitQuantity"
                >{{ $t('kitQuantity') }}</label
              >
              <div
                class="emd-select"
                :class="{
                  _state_error:
                    $v.form.kitQuantity.$invalid && $v.form.kitQuantity.$dirty
                }"
              >
                <select
                  v-model="form.kitQuantity"
                  data-testid="kitQuantity"
                  required
                >
                  <option
                    :value="null"
                    selected
                    disabled
                  >
                    {{ $t('placeholder') }}
                  </option>
                  <option
                    v-for="kit in kits"
                    :key="kit.value"
                    :value="kit.value"
                  >
                    {{ kit.label }}
                  </option>
                </select>
                <div class="emd-select__arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'

export default {
  name: 'FormRollQuantity',
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        kitQuantity: null
      },
      kits: this.generateKitsOption(10, 6)
    }
  },
  validations () {
    return {
      form: {
        kitQuantity: {
          required
        }
      }
    }
  },
  mounted () {
    this.form = { ...this.form, ...this.initialValues }
  },
  methods: {
    generateKitsOption (totalKitsToGenerate, qtyRollQtyOnKit) {
      const kits = new Array(totalKitsToGenerate)
        .fill(undefined)
        .map((_, index) => {
          const kitQty = index + 1

          return {
            value: kitQty,
            label: this.$tc('kitOptions', kitQty, {
              rollTotalAmount: kitQty * qtyRollQtyOnKit
            })
          }
        })

      return kits
    },
    submitEmitter () {
      this.$v.form.$touch()
      const isInvalid = this.$v.form.$invalid

      if (!isInvalid) {
        new PhysicalWorldFormDTO().addItem({
          kit_quantity: this.form.kitQuantity
        })
      }

      return new PhysicalWorldFormDTO().setError(isInvalid)
    }
  }
}
</script>

<style scoped>
select:required:invalid {
  color: var(--brand--form--le--border-color--focus);
}
option {
  color: var(--brand--body--le--font--color);
}
option[disabled] {
  display: none;
}
</style>

<i18n>
    {
        "pt-BR": {
            "title": "Quantidade de pacotes de bobina",
            "description": "Cada pacote contém 6 unidades de bobina.",
            "kitQuantity": "Quantidade de pacotes",
            "placeholder": "Selecione a quantidade de pacotes",
            "kitOptions":" 1 pacote (6 unidades de bobina) | {count} pacotes ({rollTotalAmount} unidades de bobina)"
        },
        "en-US": {
            "title": "Number of roll packs",
            "description": "Each package contains 6 units of roll.",
            "kitQuantity": "Quantity of packages",
            "placeholder": "Select the number of packages",
            "kitOptions":" 1 package (6 units of roll) | {count} packages ({rollTotalAmount} units of roll)"
        }
    }
</i18n>
